$(function () {
    const customizationForm = $('.customization-form, #add-to-cart');
    customizationForm.on('change', '.file-upload input[type="file"]', function (e) {
        const file = e.target.files[0];
        const information = $(this).siblings('.file-information');
        information.removeClass('d-none');
        information.children('.file-name').html(file.name + ', ' + formatBytes(file.size));

        updateFileSizes();
    });

    $('.add-file').click(function (e) {
        const imagesContainer = $(this).parent().siblings('.files-container');
        const templateFileUpload = imagesContainer.find('.file-upload-dummy');
        const templateFileUploadClone = templateFileUpload.clone();

        templateFileUploadClone.removeClass('d-none file-upload-dummy');
        imagesContainer.prepend(templateFileUploadClone);
        templateFileUploadClone.find('input[type="file"]').click();
    });

    customizationForm.on('click', '.file-remove button', function (e) {
        e.preventDefault();
        $(this).closest('.file-upload').remove();

        updateFileSizes();
    });

    function updateFileSizes() {
        let totalFilesSize = 0;
        customizationForm.find('.file-upload:not(.file-upload-dummy) input[type="file"] ').each(function () {
            totalFilesSize += this.files[0].size;
        });

        const maxFileSizeExceeded = totalFilesSize > 104857600;
        $('#add-to-cart-btn').prop('disabled', maxFileSizeExceeded);
        $('.file-size-alert').toggleClass('d-none', !maxFileSizeExceeded);
    }

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
});
